module.exports = __webpack_public_path__ + "assets/img/lg1.1b586177.jpg";